<div class="error-page">
  <div>
    <h1 class="404">404</h1>
    <p>NOT FOUND</p>
  </div>
</div>
